module.exports = __webpack_public_path__ + "img/kvalitetselement_fysisk_kjemiske.c4bf1a24.jpg";